// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { ConnectIssueModal as ConnectIssueModalType } from './index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const ConnectModal = lazy<typeof ConnectIssueModalType>(() =>
	import(/* webpackChunkName: "async-connect-issue-modal" */ './index').then(
		({ ConnectIssueModal }) => ConnectIssueModal,
	),
);

export const AsyncConnectModal = (
	props: JSX.LibraryManagedAttributes<
		typeof ConnectIssueModalType,
		ComponentProps<typeof ConnectIssueModalType>
	>,
): React.JSX.Element => (
	<Placeholder name="connect-issue-modal" fallback={null}>
		<ConnectModal {...props} />
	</Placeholder>
);
